/* Turbo minicart adapter. Never changes vendor rendering or cart data. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.start(root);
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var SELECTOR = '.mini-cart__item-property';
  function clean(node) {
    if (!node || node.nodeType !== 1) return;
    function hide(property) {
      if ((property.textContent || '').trim().charAt(0) === '_') property.remove();
    }
    if (node.matches(SELECTOR)) hide(node);
    node.querySelectorAll(SELECTOR).forEach(hide);
  }
  function start(win) {
    if (!win || win.__ttcPrivatePropertiesStarted) return;
    win.__ttcPrivatePropertiesStarted = true;
    var doc = win.document;
    clean(doc.documentElement);
    // Process added subtrees, not the whole document on every Turbo update.
    var observer = new win.MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) clean(node);
          else if (node.parentElement) clean(node.parentElement);
        });
        if (record.type === 'characterData' && record.target.parentElement) clean(record.target.parentElement);
      });
    });
    observer.observe(doc.documentElement, { childList: true, subtree: true, characterData: true });
  }
  return { clean: clean, start: start };
}));
